<script setup lang="ts">
import BaseModal from '@/components/base/BaseModal.vue'
import { useGameStore } from '@/stores/game'
import { storeToRefs } from 'pinia'
import { computed, useTemplateRef } from 'vue'

const modalRef = useTemplateRef('modalRef')
const { gameState, currentTurnPlayerProfile } = storeToRefs(useGameStore())

const activeOffer = computed(() => {
  const offerIndex = gameState.value!.activeTrade!.selectedOfferIndex as number
  return gameState.value!.activeTrade!.offers[offerIndex]
})

const open = () => {
  modalRef.value?.open()
}

const close = () => {
  modalRef.value?.close()
}

defineExpose({
  open,
  close
})
</script>

<template>
  <BaseModal ref="modalRef" class="!px-6 !pb-10 !rounded-3xl">
    <div>
      <div class="mb-9 flex flex-col gap-y-5 items-center text-center">
        <p class="text-base font-normal tracking-[-0.2px]">{{ currentTurnPlayerProfile?.username }} is answering a question</p>
        <p class="w-[70%] text-2xl font-bold text-white tracking-[-0.2px]">{{ activeOffer.question }}</p>
      </div>
      <template v-if="gameState?.activeTrade && 'isCorrectAnswer' in gameState?.activeTrade">
        <div class="p-3.5 rounded-lg bg-[#072C1E]" v-if="gameState?.activeTrade.isCorrectAnswer">
          <p class="text-base md:text-lg lg:text-xl font-bold text-cw-green text-center">{{ currentTurnPlayerProfile?.username }} picked the right answer</p>
        </div>
        <div class="p-3.5 rounded-lg bg-[#42220A]" v-else>
          <p class="text-base md:text-lg lg:text-xl font-bold text-[#DC5423] text-center">{{ currentTurnPlayerProfile?.username }} picked the wrong answer</p>
        </div>
      </template>
    </div>
  </BaseModal>
</template>
